import westfield from "./westfield";

export default {
  westfield,
};
